<script>
    import dayjs from "dayjs";
    import { mapGetters } from "vuex";
    import http from "../http";
    import FBarDate from "@/components/FBarDate";
    import FTable from "@/components/FDataInterator";
    import FChartPie from "@/components/FChartPie";

    export default {
        name: "FPageStuckFuels",
        components: { FBarDate, FTable, FChartPie },

        data: () => ({
            fuels: null,
            updatedAt: null,
            chart: {
                labels: [],
                series: []
            }
        }),

        mounted() {
            this.getFuelsList();
        },

        methods: {
            async getFuelsList() {
                const id = this.companySelected.id;
                const uri = `estoque/combustiveis/${id}`;

                try {
                    const raw = (await http.get(uri, {
                        clearCacheEntry: navigator.onLine
                    })).data;

                    const fuels = raw.data.map(f => {
                        const descricao = f.descricaoCombustivel;

                        const atual = f.estoqueAtual.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3
                        });

                        const capacidade = f.estoqueCapacidade.toLocaleString(
                            "pt-BR",
                            {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3
                            }
                        );

                        return {
                            title: descricao,
                            fields: {
                                atual: atual + "L",
                                capacidade: capacidade + "L"
                            },
                            _fields: {
                                atual: f.estoqueAtual
                            }
                        };
                    });

                    this.fuels = fuels;
                    this.updatedAt = dayjs(raw.lastSale)
                        .add(3, "hours")
                        .valueOf();
                } catch (e) {
                    this.fuels = null;
                    this.updatedAt = null;

                    console.log(e);
                }
            }
        },

        computed: {
            ...mapGetters(["companySelected", "loading"])
        }
    };
</script>

<template>
    <section class='fluid__desk_container'>
        <FBarDate disabledNav @change='this.getFuelsList' :lastUpdate='updatedAt' showDay/>

        <section>
            <FChartPie :rawData='this.fuels' labelsKey='title' seriesKey='atual'/>
            <FTable v-if='fuels' :items='fuels || []' style='margin-top: 10px'/>
        </section>
    </section>
</template>

<style>
</style>
